module.exports = __webpack_public_path__ + "img/icon-school6.eec6b669.png";